<template>
  <div class="home-videos flex-col section">
    <homeTitleVue txt="VIDEOS" toMore="/videos"/>
    <div class="flex-row justify-between">
      <div class="home-video-item">
        <video
          src="https://storagecdn.xuetangx.com/unesco/ICEE_promo.mp4"
          controls
          class="video-origin"
          poster="//storage.xuetangx.com/unesco/img/0db252e25a64d7d86f82801a27072b1c.jpg"
        ></video>
        <div class="home-video-title">ICEE Promo</div>
      </div>
      <div class="home-video-item">
        <video
          src="https://unesco.oss-cn-beijing.aliyuncs.com/file/Tsinghua%20Engineering%20Education%20Video%20for%20ASEE%202023-720P-1113.mp4"
          class="video-origin"
          poster="https://unesco.oss-cn-beijing.aliyuncs.com/images/ASEE.png"
          controls
        ></video>
        <div class="home-video-title">WU Qidi（吴启迪）</div>
      </div>
      <div class="home-video-item">
        <video
          src="https://unesco.oss-cn-beijing.aliyuncs.com/video/video3-GU%20Binglin%EF%BC%88%E9%A1%BE%E7%A7%89%E6%9E%97%EF%BC%89.mp4"
          class="video-origin"
          controls
        ></video>
        <div class="home-video-title">GU Binglin（顾秉林）</div>
      </div>
      <div class="home-video-item">
        <video
          src="https://unesco.oss-cn-beijing.aliyuncs.com/video/video13-ASEE%202024.mp4"
          class="video-origin"
          controls
        ></video>
        <div class="home-video-title">ASEE 2024</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import homeTitleVue from "./home-title.vue";
export default defineComponent({
  name: "HomeVideos",
  components: { homeTitleVue },
  setup() {
    // 此处应该有防抖函数
    return {};
  },
});
</script>
<style lang="scss" scoped>
.home-videos {
  .home-video-item {
    flex: 0 0 305px;
    margin-top: 30px;
    border-radius: 5px;
  }
  .home-video-title {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    line-height: 52px;
    border-radius: 5px;
    text-align: center;
    font-weight: 600;
    color: #423e3d;
    line-height: 28px;
    margin: 20px 20px 0;
    // font-family: "SimHei", Arial, Helvetica, sans-serif;
  }
  .video-origin {
    width: 305px;
    display: block;
    transition: all 0.2s;
    border-radius: 5px;
    &:hover {
      box-shadow: 0px 0px 20px 0px rgba(81, 85, 106, 0.36);
    }
  }
}
</style>
